import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchEmployerSolutions } from "../../../redux/actions/company_action";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  CardContainer,
  CardIcon,
  CardListContainer,
  CardText,
  CardTextContainer,
  CoverImage,
  CoverImageContainer,
  GridContainerStyled,
} from "./styles";

export default function EmployerLandingStatistics() {
  const [statisticsCard, setStatisticsCard] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const responseApi = await dispatch(fetchEmployerSolutions());

    const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
    const response = isMalaysia ? content_my : content_sg;

    const { statisticsCard } = response || {};
    setStatisticsCard(statisticsCard);
  }

  const getCardsImage = (cardsImage) => {
    return cardsImage?.url;
  };

  const getIcon = (cardIndex) => {
    if (cardIndex == 0) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          viewBox="0 0 35 35"
          fill="none"
        >
          <path
            d="M24.8602 28.75H9.86022M24.8602 28.75C27.6216 28.75 29.8602 30.9886 29.8602 33.75H4.86022C4.86022 30.9886 7.0988 28.75 9.86022 28.75M24.8602 28.75V23.125C24.8602 22.0895 24.0208 21.25 22.9852 21.25H21.5325M9.86022 28.75V23.125C9.86022 22.0895 10.6997 21.25 11.7352 21.25H13.1879M21.5325 21.25H13.1879M21.5325 21.25C20.6203 19.673 20.0427 17.8783 19.8968 15.9629M13.1879 21.25C14.1002 19.673 14.6778 17.8783 14.8237 15.9629M6.11022 4.56059C4.47306 4.79867 2.85248 5.08792 1.25018 5.42668C2.0007 9.87248 5.6851 13.3214 10.243 13.7129M6.11022 4.56059V5C6.11022 8.51297 7.72039 11.6499 10.243 13.7129M6.11022 4.56059V2.03482C9.78593 1.51751 13.5418 1.25 17.3602 1.25C21.1786 1.25 24.9345 1.51751 28.6102 2.03482V4.5606M10.243 13.7129C11.5556 14.7864 13.1153 15.5692 14.8237 15.9629M28.6102 4.5606V5C28.6102 8.51297 27.0001 11.6499 24.4775 13.7129M28.6102 4.5606C30.2474 4.79867 31.868 5.08792 33.4703 5.42669C32.7198 9.87249 29.0353 13.3214 24.4775 13.7129M24.4775 13.7129C23.1648 14.7864 21.6052 15.5692 19.8968 15.9629M19.8968 15.9629C19.0816 16.1507 18.2325 16.25 17.3602 16.25C16.488 16.25 15.6389 16.1507 14.8237 15.9629"
            stroke="#512ACC"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    } else if (cardIndex == 1) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <path
            d="M15 28.75V30.4289C15 31.755 14.4732 33.0268 13.5355 33.9645L12.5 35H27.5L26.4645 33.9645C25.5268 33.0268 25 31.755 25 30.4289V28.75M35 8.75V25C35 27.0711 33.3211 28.75 31.25 28.75H8.75C6.67893 28.75 5 27.0711 5 25V8.75M35 8.75C35 6.67893 33.3211 5 31.25 5H8.75C6.67893 5 5 6.67893 5 8.75M35 8.75V20C35 22.0711 33.3211 23.75 31.25 23.75H8.75C6.67893 23.75 5 22.0711 5 20V8.75"
            stroke="#512ACC"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <path
            d="M17.2341 26.3996C16.0859 26.3006 14.9238 26.25 13.75 26.25H12.5C8.35786 26.25 5 22.8921 5 18.75C5 14.6079 8.35786 11.25 12.5 11.25H13.75C14.9238 11.25 16.0859 11.1994 17.2341 11.1004M17.2341 26.3996C17.6555 28.0025 18.2062 29.5529 18.8744 31.039C19.2868 31.9564 18.9737 33.0546 18.1027 33.5575L17.0088 34.189C16.0898 34.7196 14.9093 34.3843 14.464 33.4211C13.4197 31.1622 12.609 28.7731 12.0631 26.2849M17.2341 26.3996C16.592 23.9575 16.25 21.3937 16.25 18.75C16.25 16.1063 16.592 13.5425 17.2341 11.1004M17.2341 26.3996C22.4999 26.854 27.4741 28.3286 31.9579 30.6249M17.2341 11.1004C22.4999 10.646 27.4741 9.17138 31.9579 6.87515M31.9579 6.87515C31.7617 6.24324 31.5503 5.61805 31.324 5M31.9579 6.87515C32.8495 9.74712 33.4262 12.7577 33.6477 15.8665M31.9579 30.6249C31.7617 31.2568 31.5503 31.8819 31.324 32.5M31.9579 30.6249C32.8495 27.7529 33.4262 24.7423 33.6477 21.6335M33.6477 15.8665C34.474 16.5544 35 17.5908 35 18.75C35 19.9092 34.474 20.9456 33.6477 21.6335M33.6477 15.8665C33.7155 16.8188 33.75 17.7804 33.75 18.75C33.75 19.7196 33.7155 20.6811 33.6477 21.6335"
            stroke="#512ACC"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <CoverImageContainer>
        <CoverImage
          src={"https://assets.hiredly.com/cms-staging/statistics-main.jpg"}
          alt="cover"
        />

        <CardListContainer>
          {statisticsCard?.map((cards, cardIndex) => (
            <>
              <CardContainer key={cardIndex} cardNumber={cardIndex}>
                <CardTextContainer>
                  <CardIcon>{getIcon(cardIndex)}</CardIcon>
                  <CardText
                    type={"desc"}
                    cardNumber={cardIndex}
                    dangerouslySetInnerHTML={{ __html: cards?.description }}
                  ></CardText>
                </CardTextContainer>
              </CardContainer>
            </>
          ))}
        </CardListContainer>
      </CoverImageContainer>
    </GridContainerStyled>
  );
}
